/** @jsx jsx */
import React, { memo } from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { CardType } from '../../../../common/types';

export type Props = {
	cardType?: CardType;
	hasMargin?: boolean;
};

export const GENERIC_ICON_URL = '/icons/issuetypes/genericissue.svg';

const cardTypeImageStyles = css({
	height: '16px',
	width: '16px',
});

const hasMarginStyles = css({
	marginRight: token('space.100', '8px'),
});

const TypeIcon = ({ cardType, hasMargin }: Props) =>
	cardType ? (
		<img
			alt={cardType.name}
			src={cardType.iconUrl}
			css={[cardTypeImageStyles, hasMargin && hasMarginStyles]}
		/>
	) : (
		<img alt="" src={GENERIC_ICON_URL} css={[cardTypeImageStyles, hasMargin && hasMarginStyles]} />
	);

export default memo<Props>(TypeIcon);
